<script>
	import appConfig from '@src/app.config'
	import Layout from '@layouts/newdefaultform'
	import PageHeader from '@components/page-header'
	import { required } from 'vuelidate/lib/validators'
	import { giftlistApi } from '@router/apiFiles/giftlistApi'
	import { chars } from '@state/modules/chars'

  /**
   * * Page
   **/
  export default {
    page: {
      title: 'Editar lista',
      meta: [{ name: 'description', content: appConfig.description }],
    },
    components: {
      Layout, PageHeader
    },
    data() {
      return {
        title: 'Editar lista',
        items: [
          {
            text: 'LaVille',
            href: '/',
          },
          {
            text: 'Listas',
            href: '/',
          },
          {
            text: 'Editar',
            active: true,
          },
        ],
		imageToUpload: null,
        states: [ 'AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MT', 'MS', 'MG', 'PA', 'PB', 'PR', 'PE', 'PI', 'RJ', 'RN', 'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO' ],
        listTypes: [ { id: 1, name: 'Casamento'}, {id:2, name: 'Chá casa nova'} ],
        id: '',
        listType: '',
        date: '',
        place: '',
        city: '',
        state: '',
		firstName1: '',
		lastName1: '',
		email1: '',
		phone1: '',
		document1: '',
		firstName2: '',
		lastName2: '',
		email2: '',
		phone2: '',
		document2: '',
        address_street: '',
        address_city: '',
        address_state: '',
        address_zipcode: '',
        address_neighborhood: '',
		address_number: '',
		address_complement: '',
		salesman: '',
		imageUrl: '',
		imageHasError: false,
		imageError: ''
      }
    },
    validations: {
      listType: { required },
      date: { required },
      place: { required },
      city: { required },
      state: { required },
    	firstName1: { required },
    	lastName1: { required },
    	phone1: { required },
    	email1: { required },
    	document1: { required },
    	firstName2: { },
    	lastName2: { },
    	phone2: { },
    	email2: { },
      document2: { },
		  address_street: { required },
		  address_city: { required },
		  address_state: { required },
		  address_zipcode: { required },
		  address_neighborhood: { required },
		  address_number: { required },
		  address_complement: { },
      form: ['id', 'listType', 'date', 'place', 'city', 'state', 'firstName1', 'lastName1', 'phone1', 'email1', 'document1', 'firstName2', 'lastName2', 'phone2', 'email2', 'document2', 'address_street', 'address_city', 'address_state', 'address_zipcode', 'address_neighborhood', 'address_number', 'address_complement' ],
    },
    mounted() {
      this.fetchData()
    },
    methods: {
			...chars,
      async fetchData() {
        var self = this;
        var urlText = self.$route.params.urlText;
        if (urlText !== 'undefined') {
          giftlistApi.getGiftlistByUrlToEdit({ url: urlText }).then(function(data){
            var toEdit = data.data;
            self.id = toEdit.id;
            self.listType = toEdit.eventType;
            self.date = toEdit.eventDate;
            self.place = toEdit.eventPlace;
            self.city = toEdit.eventCity;
            self.state = toEdit.eventState;
            self.firstName1 = toEdit.contact1_firstName;
            self.lastName1 = toEdit.contact1_lastName;
            self.email1 = toEdit.contact1_email;
            self.phone1 = toEdit.contact1_phone;
            self.document1 = toEdit.contact1_document;
            self.firstName2 = toEdit.contact2_firstName;
            self.lastName2 = toEdit.contact2_lastName;
            self.email2 = toEdit.contact2_email;
            self.phone2 = toEdit.contact2_phone;
            self.document2 = toEdit.contact2_document;
            self.address_street = toEdit.address_street;
            self.address_number = toEdit.address_number
            self.address_neighborhood = toEdit.address_neighborhood
            self.address_city = toEdit.address_city
            self.address_state = toEdit.address_state
            self.address_zipcode = toEdit.address_zipcode
            self.address_complement = toEdit.address_complement,
			self.salesman = toEdit.salesman,
			self.imageUrl = toEdit.imageUrl
          });
        }
      },
      async update() {
        var self = this;
			  giftlistApi
			  	.updateGiftlist({
					giftlistId: self.id,
          			contact1_firstName: self.firstName1,
          			contact1_lastName: self.lastName1,
          			contact1_email: self.email1,
          			contact1_phone: self.phone1,
          			contact1_document: self.document1,
          			contact2_firstName: self.firstName2,
          			contact2_lastName: self.lastName2,
          			contact2_email: self.email2,
          			contact2_phone: self.phone2,
          			contact2_document: self.document2,
          			eventType: self.listType,
          			eventDate: self.date,
          			eventPlace: self.place,
          			eventCity: self.city,
          			eventState: self.state,
          			address_street: self.address_street,
          			address_city: self.address_city,
          			address_state: self.address_state,
          			address_country: 'Brasil',
          			address_zipcode: self.address_zipcode,
          			address_neighborhood: self.address_neighborhood,
			  		address_number: self.address_number,
			  		address_complement: self.address_complement,
					salesman: self.salesman
			  	}).then(function(data) {
			  		self.$router.push({ path: '/minhaslistas' })
			  	});
      },
      async cancel() {
        this.$router.push({ path: '/minhaslistas' })
      },
	  uploadFile() {
		this.imageToUpload = this.$refs.file.files[0];
      },
      submitFile() {
		var self = this;
		giftlistApi.uploadImage({ giftlistId: this.id, file: this.imageToUpload })
			.then(function(data) {
				if (data != null) {
					if (data.success == true) {
						self.imageHasError = false;
						self.imageError = '';
						self.imageUrl = data.fileUrl;
					}
					else {
						self.imageHasError = true;
						self.imageError = data.errorMessage;
					}
				}
			});
      }
    }
  }
</script>

<template>
	<Layout>
		<PageHeader :title="title" :items="items" />
		




		<div class="row">			
			<div class="col-md-10 offset-md-1">
				<div class="card">
					<div class="card-header custom">
					</div>
					<div class="card-body">
						<h4 class="header-title mt-0 mb-1">Informações da Lista</h4>
            <br />




		<div class="row">
			<div class="col-md-6">
				<div class="form-group mt-3 mt-sm-0">
					<label>Tipo de lista</label>
					<b-form-select class="mb-2" v-model.trim="listType" :class="{ 'is-invalid': $v.listType.$error }">
						<option v-for="(option, idx) in listTypes" :key="idx" :value="option.id">{{option.name}}</option>
					</b-form-select>
					<span v-if="$v.listType.$error" class="help-block invalid-feedback">Campo obrigatório</span>
				</div>
			</div>
		</div>

		<div class="row">
			<div class="col-md-6">
				<div class="form-group mb-3">
					<label>Data do evento</label>
					<flat-pickr
						v-model.trim="date"
						class="form-control"
						name="date"
						:class="{ 'is-invalid': $v.date.$error }"
					></flat-pickr>
					<span v-if="$v.date.$error" class="help-block invalid-feedback">Campo obrigatório</span>
				</div>
			</div>
			<div class="col-md-6">
				<b-form-group label="Local do Evento">
					<b-form-input
						v-model.trim="place"
						:class="{ 'is-invalid': $v.place.$error }"
						type="text"
						placeholder="Informe o local do evento"
						v-on:keyup="removeSpecialCharsOnTyping"
						@paste.prevent
					></b-form-input>
					<span v-if="$v.place.$error" class="help-block invalid-feedback">Campo obrigatório</span>
				</b-form-group>
			</div>
		</div>	
	
		<div class="row">
			<div class="col-md-8">
				<b-form-group label="Cidade do Evento">
					<b-form-input
						v-model.trim="city"
						:class="{ 'is-invalid': $v.city.$error }"
						type="text"
						placeholder="Informe a cidade do evento"
						v-on:keyup="removeSpecialCharsOnTyping"
						@paste.prevent
					></b-form-input>
					<span v-if="$v.city.$error" class="help-block invalid-feedback">Campo obrigatório</span>
				</b-form-group>
			</div>
			<div class="col-md-4">
				<div class="form-group mt-3 mt-sm-0">
					<label for="default">Estado</label>
					<b-form-select v-model="selected" class="mb-2" :options="states" v-model.trim="state" :class="{ 'is-invalid': $v.state.$error }"></b-form-select>
				</div>
			</div>
		</div>


    <hr />
		<h4 class="header-title mt-0 mb-1">Imagem da Lista</h4>
    <br />

		<div class="row">
			<div class="col-md-3">
				<div class="form-group mt-3 mt-sm-0">
					<img v-if="imageUrl != undefined && imageUrl.length > 0" class='listimage' height="165" width="165" v-bind:src="imageUrl">
					<img v-else class='nolistimage' height="165" width="165" src="/img/no-image.jpg">
				</div>
			</div>
			<div class="col-md-6">
				<div class="form-group mt-3 mt-sm-0">
					<label>Alterar Imagem:</label>
					<br />
					<p>Selecione uma imagem <b>JPG</b> ou <b>PNG</b>, com formato <b>Quadrado</b> de até 2MB.</p>
					<input type="file" @change="uploadFile" ref="file" />
					<span v-if="imageHasError" class="inputerror">{{imageError}}</span>
					<br />
					<br />
					<button type="button" class="btn btn-primary" @click="submitFile">Salvar Imagem</button>
				</div>
			</div>
		</div>


    <hr />
		<h4 class="header-title mt-0 mb-1">Contato principal</h4>
    <br />

		<div class="row">
			<div class="col-md-6">
				<b-form-group label="Nome">
					<b-form-input
						v-model.trim="firstName1"
						:class="{ 'is-invalid': $v.firstName1.$error }"
						type="text"
						placeholder="Informe o nome"
						v-on:keyup="removeSpecialCharsOnTyping"
						@paste.prevent
					></b-form-input>
					<span v-if="$v.firstName1.$error" class="help-block invalid-feedback">Campo obrigatório</span>
				</b-form-group>
			</div>
			<div class="col-md-6">
				<b-form-group label="Sobrenome">
					<b-form-input
						v-model.trim="lastName1"
						:class="{ 'is-invalid': $v.lastName1.$error }"
						type="text"
						placeholder="Informe o sobrenome"
						v-on:keyup="removeSpecialCharsOnTyping"
						@paste.prevent
					></b-form-input>
					<span v-if="$v.lastName1.$error" class="help-block invalid-feedback">Campo obrigatório</span>
				</b-form-group>
			</div>
		</div>
	
		<div class="row">
			<div class="col-md-8">
				<b-form-group label="Email">
					<b-form-input
						v-model.trim="email1"
						:class="{ 'is-invalid': $v.email1.$error }"
						type="text"
						placeholder="Informe o email"
						readonly
					></b-form-input>
					<span v-if="$v.email1.$error" class="help-block invalid-feedback">Campo obrigatório</span>
				</b-form-group>
			</div>
			<div class="col-md-4">
				<b-form-group label="Celular">
					<b-form-input
						v-model.trim="phone1"
						:class="{ 'is-invalid': $v.phone1.$error }"
						type="text"
						v-model="phone1"
						:mask="['(##) ####-####', '(##) #####-####']"
						placeholder="Informe o celular"
					></b-form-input>
					<span v-if="$v.phone1.$error" class="help-block invalid-feedback">Campo obrigatório</span>
				</b-form-group>
			</div>
		</div>	

		<div class="row">
			<div class="col-md-6">
				<b-form-group label="CPF">
					<b-form-input
						v-model.trim="document1"
						:class="{ 'is-invalid': $v.document1.$error }"
						type="text"
						v-model="document1"
						v-mask="'###.###.###-##'"
						placeholder="Informe o CPF"
					></b-form-input>
					<span v-if="$v.document1.$error" class="help-block invalid-feedback">Campo obrigatório</span>
				</b-form-group>
			</div>
		</div>

    <hr />
		<h4 class="header-title mt-0 mb-1">Contato secundário (opcional)</h4>
		<br />

		<div class="row">
			<div class="col-md-6">
				<b-form-group label="Nome">
					<b-form-input
						v-model.trim="firstName2"
						:class="{ 'is-invalid': $v.firstName2.$error }"
						type="text"
						placeholder="Informe o nome"
						v-on:keyup="removeSpecialCharsOnTyping"
						@paste.prevent
					></b-form-input>
					<span v-if="$v.firstName2.$error" class="help-block invalid-feedback">Campo obrigatório</span>
				</b-form-group>
			</div>
			<div class="col-md-6">
				<b-form-group label="Sobrenome">
					<b-form-input
						v-model.trim="lastName2"
						:class="{ 'is-invalid': $v.lastName2.$error }"
						type="text"
						placeholder="Informe o sobrenome"
						v-on:keyup="removeSpecialCharsOnTyping"
						@paste.prevent
					></b-form-input>
					<span v-if="$v.lastName2.$error" class="help-block invalid-feedback">Campo obrigatório</span>
				</b-form-group>
			</div>
		</div>
	
		<div class="row">
			<div class="col-md-8">
				<b-form-group label="Email">
					<b-form-input
						v-model.trim="email2"
						:class="{ 'is-invalid': $v.email2.$error }"
						type="text"
						placeholder="Informe o email"
					></b-form-input>
					<span v-if="$v.email2.$error" class="help-block invalid-feedback">Campo obrigatório</span>
				</b-form-group>
			</div>
			<div class="col-md-4">
				<b-form-group label="Celular">
					<b-form-input
						v-model.trim="phone2"
						:class="{ 'is-invalid': $v.phone2.$error }"
						v-model="phone2"
						:mask="['(##) ####-####', '(##) #####-####']"
						type="text"
						placeholder="Informe o celular"
					></b-form-input>
					<span v-if="$v.phone2.$error" class="help-block invalid-feedback">Campo obrigatório</span>
				</b-form-group>
			</div>
		</div>	

		<div class="row">
			<div class="col-md-6">
				<b-form-group label="CPF">
					<b-form-input
						v-model.trim="document2"
						:class="{ 'is-invalid': $v.document2.$error }"
						v-model="document2"
						v-mask="'###.###.###-##'"
						type="text"
						placeholder="Informe o CPF"
					></b-form-input>
					<span v-if="$v.document2.$error" class="help-block invalid-feedback">Campo obrigatório</span>
				</b-form-group>
			</div>
			<div class="col-md-6">
				<b-form-group label="VND (para uso da loja)">
					<b-form-input
						v-model.trim="salesman"
						v-model="salesman"
						type="text"
						placeholder="Para uso da loja"
					></b-form-input>
				</b-form-group>
			</div>			
		</div>




    <hr />
		<h4 class="header-title mt-0 mb-1">Endereço para resgate dos produtos</h4>
		<br />

		<div class="row">
			<div class="col-md-8">
				<b-form-group label="Rua">
					<b-form-input
						v-model.trim="address_street"
						:class="{ 'is-invalid': $v.address_street.$error }"
						type="text"
						placeholder="Informe a rua"
						v-on:keyup="removeSpecialCharsOnTyping"
						@paste.prevent
					></b-form-input>
					<span v-if="$v.address_street.$error" class="help-block invalid-feedback">Campo obrigatório</span>
				</b-form-group>
			</div>
			<div class="col-md-4">
				<b-form-group label="Número">
					<b-form-input
						v-model.trim="address_number"
						:class="{ 'is-invalid': $v.address_number.$error }"
						type="text"
						placeholder="Informe o numero"
						v-on:keyup="removeSpecialCharsOnTyping"
						@paste.prevent
					></b-form-input>
					<span v-if="$v.address_number.$error" class="help-block invalid-feedback">Campo obrigatório</span>
				</b-form-group>
			</div>
		</div>	

		<div class="row">
			<div class="col-md-8">
				<b-form-group label="Bairro">
					<b-form-input
						v-model.trim="address_neighborhood"
						:class="{ 'is-invalid': $v.address_neighborhood.$error }"
						type="text"
						placeholder="Informe o bairro"
						v-on:keyup="removeSpecialCharsOnTyping"
						@paste.prevent
					></b-form-input>
					<span v-if="$v.address_neighborhood.$error" class="help-block invalid-feedback">Campo obrigatório</span>
				</b-form-group>
			</div>
			<div class="col-md-4">
				<b-form-group label="CEP">
					<b-form-input
						v-model.trim="address_zipcode"
						:class="{ 'is-invalid': $v.address_zipcode.$error }"
						type="text"
						placeholder="Informe o CEP"
					></b-form-input>
					<span v-if="$v.address_zipcode.$error" class="help-block invalid-feedback">Campo obrigatório</span>
				</b-form-group>
			</div>
		</div>

		<div class="row">
			<div class="col-md-8">
				<b-form-group label="Cidade">
					<b-form-input
						v-model.trim="address_city"
						:class="{ 'is-invalid': $v.address_city.$error }"
						type="text"
						placeholder="Informe a cidade"
						v-on:keyup="removeSpecialCharsOnTyping"
						@paste.prevent
					></b-form-input>
					<span v-if="$v.address_city.$error" class="help-block invalid-feedback">Campo obrigatório</span>
				</b-form-group>
			</div>
			<div class="col-md-4">
				<div class="form-group mt-3 mt-sm-0">
					<label for="Estado">Estado</label>
					<b-form-select v-model="address_state" class="mb-2" :options="states" v-model.trim="address_state" :class="{ 'is-invalid': $v.address_state.$error }"></b-form-select>
				</div>
			</div>
		</div>
		
		<div class="row">
			<div class="col-md-8">
				<b-form-group label="Complemento">
					<b-form-input
						v-model.trim="address_complement"
						type="text"
						placeholder="Informe o complemento"
						v-on:keyup="removeSpecialCharsOnTyping"
						@paste.prevent
					></b-form-input>
				</b-form-group>
			</div>
		</div>







              <div class="form-group row">
                <div class="col-12">
                  <button type="button" class="btn btn-primary" @click="update()">Salvar</button>
                  <button type="button" class="btn btn-secondary m-l-5 ml-1" @click="cancel()">Cancelar</button>
                </div>
              </div>



          </div>



				</div>
      </div>
    </div>	
	

  </Layout>
</template>

<style>


.ext {
    text-align: center
}

.int {
    margin: 0 auto;
    text-align: left;
    position: relative;
    width: 1170px
}

.listimage {
	border-radius: 50%;
    width: 140px !important;
    height: 140px !important;
    border: 3px solid #bcb4a3 !important;	
}

.nolistimage {
	border-radius: 50%;
    width: 140px !important;
    height: 140px !important;
    border: 3px solid #bcb4a3 !important;	
}

.inputerror {
	display: block;
	color: red;
}

</style>

